import { DataKey } from '../../Store/callAPI/allAPIs';
import { Store } from '../../Store/Store';
import { referralStatisRejected, referralStatisSuspended, TimeZones } from '../constants/CommonConstants';
import momentTimeZone from 'moment-timezone';
import lowerCase from 'lodash/lowerCase';

// Get the data from the common json file
export const getCommonJsonIdData = (id) => {
    const store = Store.getState();
    const data = store?.APIData?.GetCommonListAPI?.[DataKey]?.[id];
    return data || null;
};

export const convertUTCtoSpecificTimezone = (utcDate, timeZone, formate) => {
    const findZone = getCommonJsonIdData(TimeZones)?.find((zone) => {
        return zone.TZ === timeZone;
    });

    const localDate = momentTimeZone
        .tz(utcDate?.includes('Z') ? utcDate : utcDate + 'Z', findZone?.TZVALUE)
        .format(formate || 'MM/DD/YYYY');
    return localDate;
};

export const isReferralSuspendedOrRejected = (referralStatus) => {
    return (
        lowerCase(referralStatus) === lowerCase(referralStatisSuspended) || lowerCase(referralStatus) === lowerCase(referralStatisRejected)
    );
};

export const formatPhoneNumber = (value) => {
    // if input value is falsy eg if the user deletes the input, then just return
    if (!value) return value;

    // clean the input for any non-digit values.
    const phoneNumber = value?.replace(/[^\d]/g, '');

    // phoneNumberLength is used to know when to apply our formatting for the phone number
    const phoneNumberLength = phoneNumber?.length;

    /*
     * we need to return the value with no formatting if its less then four digits
     * this is to avoid weird behavior that occurs if you  format the area code to early
     */
    if (phoneNumberLength < 4) return phoneNumber;

    /*
     * if phoneNumberLength is greater than 4 and less the 7 we start to return
     * the formatted number
     */
    if (phoneNumberLength < 7) {
        return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
    }

    /*
     * finally, if the phoneNumberLength is greater then seven, we add the last
     * bit of formatting and return it.
     */
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};
// write a function to cut text into 200 characters
export const cutTextInto200characters = (str) => {
    if (str?.length > 250) {
        return str?.substring(0, 250);
    } else {
        return str;
    }
};
